function Payment() {
	this.build();
}

Payment.prototype.build = function () {

	if ($('#gateway_payment_forms1').length) {
		const payment = $('<div class="payment-choice"><div class="title">Moyen de paiement</div></div>');
		payment.insertBefore('.stripe_v3_div');

		const stripe = $('<div class="paiement-type stripe"><input type="radio" id="stripe" name="paymentmethod"><label class="paymentmethod" for="stripe">Carte bancaire</label></div>');
		stripe.append($('.stripe_v3_div'));
		payment.append(stripe);
		const paypal = $('<div class="paiement-type paypal"><input type="radio" id="paypal" name="paymentmethod"><label class="paymentmethod" for="paypal">Paypal</label></div>');
		paypal.append($('.paypal_div'));
		payment.append(paypal);
		const bankTransfert = $('<div class="paiement-type banktransfert"><input type="radio" id="banktransfert" name="paymentmethod"><label class="paymentmethod" for="banktransfert">Virement bancaire</label></div>');
		bankTransfert.append($('.bank_transfer_div'));
		payment.append(bankTransfert);

		$('.wpbc-payment-form').slideUp();

		$('input[name="paymentmethod"]').on('change', function () {
			$('.wpbc-payment-form').slideUp();
			$(this).siblings('.wpbc-payment-form').slideDown();
		});

		// payment.append('test');:
		// $('.stripe_v3_div, .paypal_div, .bank_transfer_div').hide();
	}
};
